import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.58594 5.00003L13.5859 12L6.58594 19L8.00015 20.4142L16.4144 12L8.00015 3.58582L6.58594 5.00003Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgChevronRight);
export default ForwardRef;
